import { IsotipoNaranja } from "@wasom/brand";

export function SiteFooter() {
  return (
    <footer className="border-t" style={{ borderColor: "var(--border)" }}>
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-3 px-6 py-10 text-center" style={{ color: "var(--text-3)" }}>
        <IsotipoNaranja style={{ width: 24, height: 24 }} />
        {/* Páginas legales ESTÁTICAS (en public/): <a> y no <Link>, porque no son rutas del SPA. */}
        <nav aria-label="Documentos legales" className="flex flex-wrap justify-center gap-x-5 gap-y-1 text-xs font-medium" style={{ color: "var(--text-2)" }}>
          <a href="/privacidad/" className="underline underline-offset-2 hover:opacity-80">Privacidad</a>
          <a href="/terminos/" className="underline underline-offset-2 hover:opacity-80">Términos</a>
          <a href="/eliminacion-de-datos/" className="underline underline-offset-2 hover:opacity-80">Eliminación de datos</a>
        </nav>
        <p className="text-xs">
          WASOM es un producto de la Suite ComPro.
          <br />
          © {new Date().getFullYear()} ComPro — Comercializadora de Productos y Servicios.
        </p>
      </div>
    </footer>
  );
}
